import React, { useEffect, useState } from 'react';
import { Button, Space, Typography } from 'antd';
import { useRecoilValue } from 'recoil';
import { compare } from 'compare-versions';
import { CloseOutlined } from '@ant-design/icons';

import { getAnnouncement } from '../../services/admin';
import version from '../version';
import states from '../../states';

const getVersionNumber = version => {
  return version.replace('v', '');
};

const AnnouncementPopup = () => {
  const [visible, setVisible] = useState(false);
  const [announcement, setAnnouncement] = useState(null);

  const admin = useRecoilValue(states.admin);

  useEffect(() => {
    checkUpdate();
  }, []);

  useEffect(() => {
    if (admin.announcement) {
      setVisible(true);
      setAnnouncement(admin.announcement);
    }
  }, [admin.announcement]);

  const checkUpdate = async () => {
    try {
      const response = await getAnnouncement();

      if (response.status === 200) {
        const announcement = response.data.announcements[0];

        if (
          announcement &&
          compare(getVersionNumber(announcement.Version), version, '>')
        ) {
          setVisible(true);
          setAnnouncement(announcement);
        }
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleClosePopup = () => {
    setVisible(false);
  };

  if (!visible || !announcement) {
    return null;
  }

  return (
    <div className="broadcast-popup">
      <div>
        <div className="broadcast-popup__header">
          <Button
            shape="circle"
            type="text"
            icon={
              <CloseOutlined
                style={{
                  fontSize: 20,
                }}
              />
            }
            onClick={handleClosePopup}
          />
        </div>
      </div>

      <div className="broadcast-popup__content">
        <Space direction="vertical" size={12}>
          {announcement?.Image && (
            <div className="broadcast-popup__img-wrapper">
              <img
                src={announcement?.Image}
                className="broadcast-popup__img"
                alt="Broadcast Popup"
              />
            </div>
          )}

          <Space
            size={0}
            direction="vertical"
            className="broadcast-popup__message"
          >
            <Typography.Title
              level={5}
              style={{
                marginBottom: 0,
              }}
            >
              {announcement?.Title}
            </Typography.Title>

            <Typography.Text
              style={{
                whiteSpace: 'break-spaces',
              }}
            >
              {announcement?.Message}
            </Typography.Text>
          </Space>

          <Button size="large" type="primary" href="/">
            Update Now to {announcement?.Version}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default AnnouncementPopup;
